import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'jalali-moment';
import {TranslateService} from '../services/translate.service';

@Pipe({
    name: 'jalaliDateTime'
})
export class JalaliDateTimePipe implements PipeTransform {
    constructor(private transl: TranslateService) {
    }

    transform(value: any, dateTimeSeparator?: any, format?: { onlyDate?: boolean, onlyTime?: boolean }): any {
        if (value === '0000-00-00') {
            return;
        }
        const separator = dateTimeSeparator ? dateTimeSeparator : ' ';
        const formatDate = this.transl.dir === 'rtl' ? 'jYYYY-jMM-jDD' : 'YYYY-MM-DD';
        const formatTime = 'hh:mm A';
        if (value) {
            const momentDate = moment(new Date(value)).locale(this.transl.lang);
            if (format && format.onlyDate) {
                return momentDate.format(formatDate);
            }
            if (format && format.onlyTime) {
                return momentDate.format(formatTime);
            }
            return momentDate.format(formatDate) + separator + momentDate.format(formatTime);
        }
    }

  getCurrentJalaliYear() {
    return moment().jYear(); // Get the Jalali year
  }
    currentFiscalYear(value: any): any {
        if (value === '0000-00-00') {
            return;
        }
        if (value) {
            const momentDate = moment(new Date(value)).locale(this.transl.lang);
            const year = +momentDate.format('jYYYY');
            const month = +momentDate.format('jMM');
            if (month > 12) {
                return year + 1;
            }
            return year;
        }
    }
}
